module.exports = __webpack_public_path__ + "img/uk-colorectal-cancer-male.df6eab5c.png";